import view from './view';
import reducer from './reducer';

export {view, reducer};
